const titleCaseProcessableWordPattern = /[^\s-().,:"'!?\]\[{}\\\/|´;><+]+/g

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function smartTitleCase(text: string): string {
  if (!text) return text

  // Normaliza espaços (NBSP)
  const normalized = text
    .replace(/\u00A0/g, ' ') // non-breaking space -> espaço normal
    .replace(/\s+/g, ' ') // colapsa espaços em branco
    .trim()

  const lowercaseExceptions: Set<string> = new Set([
    'da',
    'de',
    'do',
    'dos',
    'das',
    'e',
    'em',
    'a',
    'o',
    'as',
    'os',
    'para',
    'com',
    'por',
    'no',
    'na',
    'nos',
    'nas',
  ])

  const exactCaseExceptions = new Map(['MEIs'].map(term => [term.toLowerCase(), term]))

  const correctCasePhraseExceptions = new Map(
    ['UP Digital', 'NF-e', '5D & 6D', 'Boleto DAS', 'DAS - Boleto', 'Boleto MEI (DAS)'].map(
      term => [escapeRegExp(term.toLowerCase()), term],
    ),
  )

  const uppercaseExceptions: Set<string> = new Set([
    'i',
    'ii',
    'iii',
    'iv',
    'v',
    'vi',
    'vii',
    'viii',
    'ix',
    'x',
    'xi',
    'xii',
    'xiii',
    'xiv',
    'xv',
    'xvi',
    'xvii',
    'xviii',
    'xix',
    'xx',
    'xxi',
    'xxii',
    'xxiii',
    'xxiv',
    'xxv',
    'xxvi',
    'xxvii',
    'xxviii',
    'xxix',
    'xxx',
    'br',
    'ead',
    'sebrae',
    'cnae',
    'mei',
    'me',
    'epp',
    'nf',
    '5d',
    '6d',
  ])

  let titleCaseWordIndex = 0

  const applyTitleCaseToWord = (word: string, wordIndex: number): string => {
    const lower = word.toLowerCase()
    const exactCaseException = exactCaseExceptions.get(lower)

    if (exactCaseException) {
      return exactCaseException
    } else if (lowercaseExceptions.has(lower) && wordIndex !== 0) {
      return lower
    } else if (uppercaseExceptions.has(lower)) {
      return lower.toUpperCase()
    }

    return lower.charAt(0).toUpperCase() + lower.slice(1)
  }

  const finalText = normalized.replace(titleCaseProcessableWordPattern, word => {
    // A pontuação fica fora do match e permanece na posição original.
    const titleCaseWord = applyTitleCaseToWord(word, titleCaseWordIndex)
    titleCaseWordIndex += 1
    return titleCaseWord
  })

  const finalTextPostProcess = [...correctCasePhraseExceptions.entries()].reduce(
    (result, [lowerPhrase, correctPhrase]) =>
      result.replace(new RegExp(lowerPhrase, 'gi'), correctPhrase),
    finalText,
  )

  return finalTextPostProcess
}
